export default __webpack_public_path__ + "static/media/LogoC1Default.858e6a2a.svg";